import { useMemo } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { UserData } from '../../types';

const TYPE_COLORS: Record<string, string> = {
  'Lawyer': '#2563eb',
  'Law Student': '#8b5cf6',
  'Paralegal': '#f59e0b',
  'Researcher': '#10b981',
  'Other': '#ef4444',
  'Unknown': '#9ca3af',
};

interface UserTypeChartProps {
  users: UserData[];
}

export function UserTypeChart({ users }: UserTypeChartProps) {
  const data = useMemo(() => {
    const counts: Record<string, number> = {};
    users.forEach(user => {
      const type = user.userType || 'unknown';
      counts[type] = (counts[type] || 0) + 1;
    });
    return Object.entries(counts).map(([name, value]) => ({
      name: name.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
      value,
    }));
  }, [users]);

  const renderLabel = ({ name, percent }: { name: string; percent: number }) =>
    `${name} ${(percent * 100).toFixed(0)}%`;

  return (
    <div className="chart-card">
      <h3>User Types</h3>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label={renderLabel}>
            {data.map((entry, i) => (
              <Cell key={i} fill={TYPE_COLORS[entry.name] || '#6b7280'} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
